module.exports = __webpack_public_path__ + "img/guide.36680e1c.png";